exports = module.exports = {
    PageSize: 10,
    SlackAPI: "https://f09hhgz7j5.execute-api.us-west-2.amazonaws.com/Slack/SlackBlogNotification",
    MyDomain: "https://www.smilingleo.net"
}


// WEBPACK FOOTER //
// ./src/constant.js